
import WhistlerHero from './components/WhistlerHero';
import WhistlerOverview from './components/WhistlerOverview';
import WhistlerLicensing from './components/WhistlerLicensing';
import WhistlerZoning from './components/WhistlerZoning';
import WhistlerMarket from './components/WhistlerMarket';
import { WhistlerEnforcement } from './components/WhistlerEnforcement';
import WhistlerCTA from './components/WhistlerCTA';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function WhistlerSTRPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <WhistlerHero />
        <WhistlerOverview />
        <WhistlerLicensing />
        <WhistlerZoning />
        <WhistlerMarket />
        <WhistlerEnforcement />
        <WhistlerCTA />
      </main>
      <Footer />
    </div>
  );
}
